"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TopArea = require("./TopArea");
Object.keys(_TopArea).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TopArea[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TopArea[key];
    }
  });
});
var _TopAreaFeature = require("./TopAreaFeature");
Object.keys(_TopAreaFeature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TopAreaFeature[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TopAreaFeature[key];
    }
  });
});
var _TopAreaLoader = require("./TopAreaLoader");
Object.keys(_TopAreaLoader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TopAreaLoader[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TopAreaLoader[key];
    }
  });
});
